// libraries.
import { Container } from 'react-bootstrap';

// components.
import { WrapperPolygonTitle } from '../../DocumentsAuditDashboard/components/DocumentsActionsBar/components/DocumentsTitleBar';
import { SearchNid } from './SearchNid';
import { BusinessLineDropdown } from './BusinessLineDropdown';

export const GeoreferencingTitle = () => {
  return (
    <Container
      fluid
      className="p-4 pb-3 d-flex justify-content-between align-items-center"
      style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.16)' }}
    >
      <WrapperPolygonTitle className="d-flex flex-column align-items-center w-100">
        <div className="d-flex w-100 gap-2 flex-column">
          <div className="d-flex">Corrección de datos</div>
        </div>
      </WrapperPolygonTitle>
      <div className="d-flex gap-3 align-items-center justify-content-end w-100">
        <BusinessLineDropdown />
        <SearchNid />
      </div>
    </Container>
  );
};
